import { Injectable } from '@angular/core';
import { AiResponseProcessor, ImageConfigType, InstantCheckupType } from '@cureskin/ai-response-processor';
import {Entity} from "@cureskin/api-client-rn";

@Injectable( { providedIn: 'root' } )
export class AiImageProcessorServices {
  private readonly aiResponseProcessor: AiResponseProcessor = new AiResponseProcessor();

  constructor() {}

  getFrontFaceImageConfig(instantCheckUp: Entity['InstantCheckup']): ImageConfigType {
    return this.aiResponseProcessor.getFrontFaceImageConfig(instantCheckUp as unknown as InstantCheckupType);
  }

  getSideFaceImageConfig(instantCheckUp: Entity['InstantCheckup']): ImageConfigType {
    return this.aiResponseProcessor.getSideFaceImageConfig(instantCheckUp as unknown as InstantCheckupType);
  }

}
